var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusPendingWResendStamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.545,
    height: 18.028,
    viewBox: "0 0 20.545 18.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#f05a2f;stroke-linecap:round;}.b{fill:#f15a30;}.c{stroke:#f15a30;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.02 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,0V3",
    transform: "translate(8.253 6.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,1H1",
    transform: "translate(8.253 11.028)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8.253 11.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.138,1.465a1,1,0,0,1,1.724,0l8.252,14.028A1,1,0,0,1,18.252,17H1.748a1,1,0,0,1-.862-1.507Z",
    transform: "translate(-0.747 -0.972)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPendingWResendStamp);
export default __webpack_public_path__ + "static/media/status-pending-w-resend-stamp.10c02067c147b3ebb223896ff8d34051.svg";
export { ForwardRef as ReactComponent };